import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable,throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { SnackbarService } from '../services';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

  constructor(
    private snackbar:SnackbarService,
    private router:Router
  ) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<any> {
    return next.handle(request).pipe(catchError((err : HttpErrorResponse): any => {

      if (err.status === 0) {
        const isAbort =
          typeof ProgressEvent !== 'undefined'
          && err.error instanceof ProgressEvent
          && err.error.type === 'abort';

        if (isAbort) {
          return throwError(() => ({ cancelled: true }));
        }

        return throwError(() => 'Server is not reachable, Please try again later.');
      }

      if (err.status === 400 || err.status === 409) {
        const message = err.error?.message || 'Bad request or conflict error';
        return throwError(() => message);
      }
      
      if (err.status === 401) {
        return throwError(() => err);
      }

      if (err.status === 403) {
        return throwError(() => 'You do not have permission to perform this action.');
      }

      if (err.status === 422) {
        return throwError(() => err);
      }

      if (err.status === 429) {
        return throwError(() => 'Too many attempts, please wait and try again later');
      }

      if (err.status === 503 || err.status === 502) {
        this.router.navigateByUrl('/maintenance');
        return throwError(() => 'Service unavailable. Redirecting to maintenance.');
      }

      // Default fallback
      const fallbackMessage = err.error?.message || 'An unexpected error occurred';
      this.snackbar.showNotification('info', '', fallbackMessage, 'Close');
      return throwError(() => fallbackMessage);
    }));
  }
}
